import { Link } from "@sitecore-jss/sitecore-jss-react";
import React, { FunctionComponent, useState } from "react";
import { FooterProps } from "../types/Footer.types";
import "./FooterSocial.scss";

interface FooterSocialItemProps {
  to: any;
  iconClassName: string;
  onClick?: Function;
}

const FooterSocial: FunctionComponent<{
  socialList: FooterProps["fields"]["socialLinks"];
}> = ({ socialList }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubtitle] = useState("");
  const [modalQr, setModalQr] = useState("");
  const OpenWeChatPopup = (title, subTitle, qrCode) => {
    setModalQr(qrCode);
    setModalTitle(title);
    setModalSubtitle(subTitle);
    setIsModalOpen(true);
  };
  const FooterSocialItem: FunctionComponent<FooterSocialItemProps> = ({
    to,
    iconClassName,
    onClick,
  }) => {
    return (
      <li>
        <a
          href={to?.value?.href !== "" ? to?.value?.href : null}
          className={`icon ${iconClassName} ga4-click-ui-footer`}
          target={to?.value?.target}
          rel="noopener noreferrer"
          onClick={() => onClick()}
        />
      </li>
    );
  };
  const hosts = {
    facebook: "icon-facebook_bottom_bar",
    linkedin: "icon-linkedin_bottom_bar",
    youtube: "icon-youtube_bottom_bar",
    twitter: "icon-twitter_bottom_bar",
    instagram: "icon-instagram_bottom_bar",
    spotify: "icon-spotify_bottom_bar",
    weibo: "icon-weibo_white",
    wechat: "icon-wechat_white",
    flickr: "icon-flickr_bottom_bar",
    blogdafpt: "icon-blog",
  };
  const getIconByHostname: (hostname: string) => string = (hostname) => {
    for (let key in hosts) if (hostname?.includes(key)) return hosts[key];
    return "";
  };

  return (
    <div className="FooterSocial">
      <div
        className={"FooterSocial__wechat_modal"}
        style={isModalOpen ? { display: "block" } : { display: "none" }}
      >
        <div className={"FooterSocial__wechat_modal_content"}>
          <div className={"icon_close_container"}>
            <span
              className={"icon icon-close"}
              onClick={() => setIsModalOpen(false)}
            />
          </div>
          <h4 className={"header"}>{modalTitle}</h4>
          <p className={"modal_text"}>{modalSubTitle}</p>
          <div className={"qr_container"}>
            <img src={modalQr} className={"wechat_qr"} />
          </div>
        </div>
      </div>
      <nav>
        <ul>
          {socialList?.length > 0 &&
            socialList.map((socialItem, idx) => (
              <FooterSocialItem
                key={idx}
                to={socialItem?.fields?.["Social Link"]}
                iconClassName={
                  socialItem.fields?.["Social Link"]
                    ? getIconByHostname(
                        socialItem?.fields?.["Social Link"]?.value?.href
                      )
                    : socialItem?.fields?.Icon?.value
                }
                onClick={
                  socialItem?.fields?.QrCodeImage
                    ? () =>
                        OpenWeChatPopup(
                          socialItem?.fields?.Title?.value,
                          socialItem?.fields?.SubTitle?.value,
                          socialItem?.fields?.QrCodeImage?.value?.src
                        )
                    : () => {}
                }
              />
            ))}
        </ul>
      </nav>
    </div>
  );
};

export default FooterSocial;
